import { FC } from "react";
import {
  LiRestricedCode,
  SectionTitle,
  SenasaRestrictedCodesContainer,
  ULRestrictedCodes,
} from "./SenasaRestrictedCodesStyles";

interface SenasaRestrictedCodesProps {
  className?: string;
  margins?: number[];
  restrictedCodes: string[];
}

const SenasaRestrictedCodes: FC<SenasaRestrictedCodesProps> = ({
  className,
  restrictedCodes,
  margins,
}) => {
  const margin = margins?.map((m) => m + "px").join(" ") ?? "";
  return restrictedCodes.length > 0 ? (
    <SenasaRestrictedCodesContainer className={className} margin={margin}>
      <SectionTitle>Partidas restringidas</SectionTitle>
      <ULRestrictedCodes>
        {restrictedCodes.map((code) => (
          <LiRestricedCode key={code}>{code}</LiRestricedCode>
        ))}
      </ULRestrictedCodes>
    </SenasaRestrictedCodesContainer>
  ) : null;
};

export default SenasaRestrictedCodes;
